import * as fromDatatype from "../datatype-library/index";

export interface bl_url_hyperlink_click_event_fact_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hyperlink_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  report_type: fromDatatype.VarcharDatatypeInterface;
  report_code: fromDatatype.VarcharDatatypeInterface;
  report_option: fromDatatype.VarcharDatatypeInterface;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  value_string: fromDatatype.VarcharDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_datetime:  fromDatatype.TimestampTzDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  date1_year: fromDatatype.IntegerDatatypeInterface;
  date1_month:  fromDatatype.IntegerDatatypeInterface;
  date1_day: fromDatatype.IntegerDatatypeInterface;
  date1_hour: fromDatatype.IntegerDatatypeInterface;
  date1_minute: fromDatatype.IntegerDatatypeInterface;
  date2_year: fromDatatype.IntegerDatatypeInterface;
  date2_month: fromDatatype.IntegerDatatypeInterface;
  date2_day: fromDatatype.IntegerDatatypeInterface;
  date2_hour: fromDatatype.IntegerDatatypeInterface;
  date2_minute: fromDatatype.IntegerDatatypeInterface;
  utm_source: fromDatatype.VarcharDatatypeInterface;
  utm_medium: fromDatatype.VarcharDatatypeInterface;
  utm_campaign: fromDatatype.VarcharDatatypeInterface;
  utm_term: fromDatatype.VarcharDatatypeInterface;
  utm_content: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_url_hyperlink_click_event_fact_RowClass implements bl_url_hyperlink_click_event_fact_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hyperlink_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  report_type: fromDatatype.VarcharDatatypeInterface;
  report_code: fromDatatype.VarcharDatatypeInterface;
  report_option: fromDatatype.VarcharDatatypeInterface;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  value_string: fromDatatype.VarcharDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_datetime:  fromDatatype.TimestampTzDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  date1_year: fromDatatype.IntegerDatatypeInterface;
  date1_month:  fromDatatype.IntegerDatatypeInterface;
  date1_day: fromDatatype.IntegerDatatypeInterface;
  date1_hour: fromDatatype.IntegerDatatypeInterface;
  date1_minute: fromDatatype.IntegerDatatypeInterface;
  date2_year: fromDatatype.IntegerDatatypeInterface;
  date2_month: fromDatatype.IntegerDatatypeInterface;
  date2_day: fromDatatype.IntegerDatatypeInterface;
  date2_hour: fromDatatype.IntegerDatatypeInterface;
  date2_minute: fromDatatype.IntegerDatatypeInterface;
  utm_source: fromDatatype.VarcharDatatypeInterface;
  utm_medium: fromDatatype.VarcharDatatypeInterface;
  utm_campaign: fromDatatype.VarcharDatatypeInterface;
  utm_term: fromDatatype.VarcharDatatypeInterface;
  utm_content: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
